import React from "react"
import PropTypes from "prop-types"
import { Card, Segment, Grid, Icon, Statistic } from "semantic-ui-react"
import pickPlural from "../utils/pluralNameHelper"
import { withTranslation } from "react-i18next"

export class DailyAnalyticsData {
  constructor(
    firstPropUnit,
    secondPropUnit,
    currentFirstProp,
    currentSecondProp,
    oldFirstProp,
    oldSecondProp,
  ) {
    this.currentValues = [currentFirstProp, currentSecondProp]
    this.oldValues = [oldFirstProp, oldSecondProp]
    this.units = [firstPropUnit, secondPropUnit]
    this.difIcons = [
      this.currentValues[0] > this.oldValues[0] ? "triangle up" : "dropdown",
      this.currentValues[1] > this.oldValues[1] ? "triangle up" : "dropdown",
    ]
    this.difValues = [
      (Math.abs(
        parseInt((100 * this.currentValues[0]) / this.oldValues[0] - 100),
      ) || 0) + "%",
      (Math.abs(
        parseInt((100 * this.currentValues[1]) / this.oldValues[1] - 100),
      ) || 0) + "%",
    ]
  }

  renderCurrent() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={13}>
            <Statistic
              size="tiny"
              label={pickPlural(this.currentValues[0], this.units[0])}
              value={this.currentValues[0]}
              horizontal
            />
          </Grid.Column>
          <Grid.Column
            width={3}
            className={"analytics-prop-" + this.difIcons[0][0]}
          >
            <Icon name={this.difIcons[0]} />
            {this.difValues[0]}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={13}>
            <Statistic
              size="tiny"
              label={pickPlural(this.currentValues[1], this.units[1])}
              value={this.currentValues[1]}
              horizontal
            />
          </Grid.Column>
          <Grid.Column
            width={3}
            className={"analytics-prop-" + this.difIcons[1][0]}
          >
            <Icon name={this.difIcons[1]} />
            {this.difValues[1]}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }

  renderOld() {
    return (
      <div>
        <Statistic
          size="mini"
          label={pickPlural(this.oldValues[0], this.units[0])}
          value={this.oldValues[0]}
          horizontal
        />
        <br />
        <Statistic
          size="mini"
          label={pickPlural(this.oldValues[1], this.units[1])}
          value={this.oldValues[1]}
          horizontal
        />
      </div>
    )
  }
}

class DailyAnalyticsCardWithTranslate extends React.Component {
  render() {
    const { t } = this.props
    const { title, data, isLoading } = this.props
    return (
      <Segment
        as={Card}
        loading={isLoading}
        fluid
        className="daily-analytics-card"
      >
        <Card.Content>
          <Card.Header content={title} />
          <Card.Meta content={t("today")} />
          {data.renderCurrent()}
        </Card.Content>
        <Card.Content extra>
          <Card.Meta content={t("yesterday")} />
          {data.renderOld()}
        </Card.Content>
      </Segment>
    )
  }
}

DailyAnalyticsCardWithTranslate.propTypes = {
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  data: PropTypes.instanceOf(DailyAnalyticsData).isRequired,
}

export const DailyAnalyticsCard = withTranslation()(
  DailyAnalyticsCardWithTranslate,
)
